import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { appI18n } from 'i18n';
import { paths, ROOT_PATHS, SUB_PATHS } from './paths';

import { Outlet, Navigate } from 'react-router-dom';

import { MainLayout } from 'components/Layout';

import { RequestAccessForm } from 'features/auth/components/RequestAccessForm';
import { ConsortiumGroupSuppliers, ConsortiumGroupFiles, SuppliersFiles, DetailsView, List as FAList } from 'features/frameworkAgreements';
import { ConsortiumGroupSuppliers as DCGS, ConsortiumGroupFiles as DCGF, SuppliersFiles as DSF, DetailsView as DDV, List as DirectsList } from 'features/direct';
import { DetailsView as DPSDV, List as DPSList } from 'features/dps';
import { List as CompaniesList, DetailsView as CompaniesDetailsView, UsersList as CompaniesUsersList, PublicProfile } from 'features/companies';
import { UserDetails, List as UsersList } from 'features/users';
import { List as SubscriptionsList } from 'features/subscriptions';
import { List as SubscribersList } from 'features/subscribers';
import { Statistics } from 'features/statistics';
import { Settings } from 'features/settings';
import { List as BlogList } from 'features/blog';
import { DetailsView as BlogDetails } from 'features/blog';
import { List as JobAdsList, DetailsView as JobAdDetails, MyAdsList, MyAdDetailsView, AdminList, AdminDetails, ApplicationsList, ApplicationDetailsView } from 'features/jobAds';
import { useAuth } from 'lib/auth'; // This import was added before, removing it if not used by JobAdDetails

import { Logout } from './Logout';
import { AccessRequested } from 'features/auth/components/AccessRequested';
import { Homepage } from 'features/home';
import FilterLayout from 'components/Layout/FilterLayout';
import { NotificationsList } from 'features/notifications';
import EmailTemplatePreview from 'pages/EmailTemplatePreview';
import AuthEmailTemplatePreview from 'pages/AuthEmailTemplatePreview';
import { JobAdPreferencesProvider } from 'contexts/JobAdPreferencesContext';
import { SupplierSearch } from 'features/supplierSearch';
import { isBuyer } from 'utils/companyType';

const JobAdsRouter = () => {
  const { account } = useAuth();
  return account.super_admin ? <AdminList /> : <JobAdsList />;
};

const AdminJobAdDetailsRoute = () => {
  const { account } = useAuth();
  return account.super_admin ? <AdminDetails /> : <Navigate to=".." relative="path" replace />;
};

const SupplierSearchRoute = () => {
  const { account, user } = useAuth();
  return account.super_admin || isBuyer(user) ? <SupplierSearch /> : <Navigate to={paths.homepage} replace />;
};

const App = () => {
  return (
    // <JobAdPreferencesProvider>
    <I18nextProvider i18n={appI18n}>
      <MainLayout>
        <Outlet />
      </MainLayout>
    </I18nextProvider>
    // </JobAdPreferencesProvider>
  );
};

export const protectedRoutes = [
  {
    path: '/app',
    element: <App />,
    children: [
      { path: `${ROOT_PATHS.FRAMEWORK_AGREEMENT}`, element: <FAList /> },
      { path: `${ROOT_PATHS.FRAMEWORK_AGREEMENT_DETAILS}`, element: <DetailsView /> },
      {
        path: `${ROOT_PATHS.FRAMEWORK_AGREEMENT_DETAILS}/${SUB_PATHS.frameworkAgreement.consortiumGroupDetails}`,
        element: <ConsortiumGroupSuppliers />,
      },
      {
        path: `${ROOT_PATHS.FRAMEWORK_AGREEMENT_DETAILS}/${SUB_PATHS.frameworkAgreement.consortiumGroupFiles}`,
        element: <ConsortiumGroupFiles />,
      },
      {
        path: `${ROOT_PATHS.FRAMEWORK_AGREEMENT_DETAILS}/${SUB_PATHS.frameworkAgreement.suppliersFiles}`,
        element: <SuppliersFiles />,
      },
      { path: `${ROOT_PATHS.REQUEST_ACCESS}`, element: <RequestAccessForm /> },
      { path: `${ROOT_PATHS.ACCESS_REQUESTED}`, element: <AccessRequested /> },
      { path: `${ROOT_PATHS.LOGOUT}`, element: <Logout /> },
      { path: `${ROOT_PATHS.BUYERS}`, element: <CompaniesList companyType={"buyer"}/> },
      { path: `${ROOT_PATHS.BUYERS_DETAILS}`, element: <CompaniesDetailsView key={'buyer'} cType={"buyer"}/> },
      { path: `${ROOT_PATHS.BUYERS_USERS}`, element: <CompaniesUsersList key={'buyer'} companyType={"buyer"} /> },
      { path: `${ROOT_PATHS.SUPPLIERS}`, element: <CompaniesList companyType={"supplier"} /> },
      { path: `${ROOT_PATHS.SUPPLIERS_DETAILS}`, element: <CompaniesDetailsView key={'supplier'} cType={"supplier"} /> },
      { path: `${ROOT_PATHS.SUPPLIERS_USERS}`, element: <CompaniesUsersList key={'supplier'} companyType={"supplier"} /> },
      { path: `${ROOT_PATHS.SUPPLIER_SEARCH}`, element: <SupplierSearchRoute /> },
      { path: `${ROOT_PATHS.USERS}`, element: <UsersList /> },
      { path: `${ROOT_PATHS.USER_DETAILS}`, element: <UserDetails /> },
      { path: `${ROOT_PATHS.SUBSCRIPTIONS}`, element: <SubscriptionsList /> },
      { path: `${ROOT_PATHS.SUBSCRIBERS}`, element: <SubscribersList /> },
      { path: `${ROOT_PATHS.STATISTICS}`, element: <Statistics /> },
      { path: `${ROOT_PATHS.SETTINGS}`, element: <Settings /> },
      { path: `${ROOT_PATHS.DIRECTS}`, element: <DirectsList /> },
      { path: `${ROOT_PATHS.DIRECTS_DETAILS}`, element: <DDV /> },
      { path: `${ROOT_PATHS.DPS}`, element: <DPSList /> },
      { path: `${ROOT_PATHS.DPS_DETAILS}`, element: <DPSDV /> },
      {
        path: `${ROOT_PATHS.DIRECTS_DETAILS}/${SUB_PATHS.directs.consortiumGroupDetails}`,
        element: <DCGS />,
      },
      {
        path: `${ROOT_PATHS.DIRECTS_DETAILS}/${SUB_PATHS.directs.consortiumGroupFiles}`,
        element: <DCGF />,
      },
      {
        path: `${ROOT_PATHS.DIRECTS_DETAILS}/${SUB_PATHS.directs.suppliersFiles}`,
        element: <DSF />,
      },
      { path: `${ROOT_PATHS.BLOG}`, element: <BlogList /> },
      { path: `${ROOT_PATHS.BLOG_DETAILS}`, element: <BlogDetails /> },
      // { path: `${ROOT_PATHS.JOB_ADS}`, element: <JobAdsList /> },
      { path: `${ROOT_PATHS.JOB_ADS_DETAILS}`, element: <JobAdDetails /> },
      { path: `${ROOT_PATHS.ADMIN_JOB_ADS_DETAILS}`, element: <AdminJobAdDetailsRoute /> },
      // { path: `${ROOT_PATHS.MY_JOB_ADS}`, element: <MyAdsList /> },
      { path: `${ROOT_PATHS.MY_JOB_ADS_DETAILS}`, element: <MyAdDetailsView /> },
      { path: `${ROOT_PATHS.APPLICATIONS}`, element: <ApplicationsList /> },
      { path: `${ROOT_PATHS.APPLICATION_DETAILS}`, element: <ApplicationDetailsView /> },
      { path: `${ROOT_PATHS.NOTIFICATIONS}`, element: <NotificationsList /> },
      {
        element: <FilterLayout />,
        children: [
          {
            path: `${ROOT_PATHS.JOB_ADS}`,
            element: <JobAdsRouter />,
          },
          {
            path: `${ROOT_PATHS.HOMEPAGE}`,
            element: <JobAdsList isHomePage />,
          },
          // {
          //   path: `${ROOT_PATHS.JOB_ADS_DETAILS}`,
          //   element: <JobAdDetails />,
          // },
          {
            path: `${ROOT_PATHS.MY_JOB_ADS}`,
            element: <MyAdsList />,
          },
          // {
          //   path: `${ROOT_PATHS.MY_JOB_ADS_DETAILS}`,
          //   element: <MyAdDetailsView />,
          // },
        ],
      },
      { path: 'dev/template-preview', element: <EmailTemplatePreview /> },
      { path: 'dev/auth-template-preview', element: <AuthEmailTemplatePreview /> },
    ],
  },
  // Also under the /:lang prefix public profile links carry, so logged-in users keep getting the in-app view
  ...[ROOT_PATHS.COMPANY_PUBLIC_PROFILE, ROOT_PATHS.LOCALIZED_COMPANY_PUBLIC_PROFILE].map((path) => ({
    path,
    element: <App />,
    children: [
      { path: ``, element: <CompaniesDetailsView param="slug"/> },
    ],
  })),
];